import { Box, Skeleton, Stack, TableRow } from '@mui/material';
import { StyledTableCell } from '../styles';

type Props = {
  showAvatarColumn?: boolean;
  noOfSimpleColumns?: number;
  showActionColumn?: boolean;
};

export const TableSkeleton = ({
  showAvatarColumn = true,
  noOfSimpleColumns = 2,
  showActionColumn = true,
}: Props) => {
  return (
    <Box sx={{ my: 1 }}>
      {[...Array.from({ length: 9 }).keys()].map((index) => (
        <TableRow key={index} data-testid="skeleton-row">
          {showAvatarColumn && (
            <StyledTableCell sx={{ width: '300px' }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="text" width={100} height={40} />
              </Stack>
            </StyledTableCell>
          )}

          {[...Array.from({ length: noOfSimpleColumns }).keys()].map((count) => (
            <StyledTableCell key={count} sx={{ width: '100%' }}>
              <Skeleton variant="text" width={250} height={40} />
            </StyledTableCell>
          ))}
          {showActionColumn && (
            <StyledTableCell sx={{ width: 72 }}>
              <Skeleton variant="rounded" width={72} height={25} />
            </StyledTableCell>
          )}
        </TableRow>
      ))}
    </Box>
  );
};
